
export default {
  name: 'AppDialogDefault',
  props: {
    title: { type: String, required: true },
    showCloseButton: { type: Boolean, default: false },
    hideFoot: { type: Boolean, default: false }
  }
};
